module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    staticClass: "mobile-btn",
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    staticClass: "mobile-font",
    attrs: {
      "center": ""
    }
  }, [_vm._v("All Deleted Request Assignment Details")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "10"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()]), _vm._v(" "), (_vm.Total_Delete_RequestList.length > 0) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('All_Sales_Execution_Delete_List')
      }
    }
  }, [_vm._v("Export as Excel")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.Total_Delete_RequestList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "jobType",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_c('md-icon', [_vm._v(_vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "directions_boat" :
          "flight_takeoff"))]), _vm._v(" "), _c('b', {
          staticClass: "showMoreData",
          attrs: {
            "disabled": row1.item.asignDeleted == '1'
          },
          on: {
            "click": function($event) {
              _vm.viewExportFCLConPage(row1.item.allModuleId, row1.item.isMiscJob)
            }
          }
        }, [_vm._v(_vm._s(row1.item.mainSalesSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt. : " + _vm._s(_vm._f("moment")(row1.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Job Type : " + _vm._s(row1.item.jobType) + " (" + _vm._s(row1.item.shipmentType == "1" ||
          row1.item.shipmentType == "Sea_Shipment" ?
          "Sea" :
          "Air") + "\n                    " + _vm._s(row1.item.transportType) + ")\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.baseLoc))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(" By : " + _vm._s(row1.item.raisedBy))]), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), (row1.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' +
              row1.item.mainSalesSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.mainSalesSeries,
            "PMC_JOBDATE": _vm._f("moment")(row1.item.loginTime),
            "PMC_JOBTYPE": row1.item.jobType,
            "PMC_Client": row1.item.TPTClient,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.mainSalesSeries
          }
        }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.splitFromId != '0') ? _c('h7', {
          staticClass: "mt-2"
        }, [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Split of " + _vm._s(row1.item.splitFromNo))])], 1) : _vm._e(), _vm._v(" "), _c('h6', [(row1.item.asignDeleted == '1') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Assignment Deleted")]) : _vm._e()], 1)]
      }
    }, {
      key: "TPTClient",
      fn: function(row11) {
        return [(
          row11.item.clientType == '3' &&
          row11.item.transportType == 'Export'
        ) ? _c('b', [_vm._v("\n                    Client Name : " + _vm._s(row11.item.exporter) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType == '3') ? _c('b', [_vm._v("\n                    Overseas Agent : " + _vm._s(row11.item.TPTClient) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row11.item.clientType != '3') ? _c('b', [_vm._v("\n                    " + _vm._s(row11.item.TPTClient) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "mainEnquirySeries",
      fn: function(row2) {
        return row2.item.EnqJob ? [_c('span', [_vm._v(_vm._s(row2.item.mainEnquirySeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Type : " + _vm._s(row2.item.EnqJob) + " (" + _vm._s(row2.item.shipmentType == "1" ? "Sea" : "Air") + "\n                    " + _vm._s(row2.item.transportType) + ")")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Enquiry Date : " + _vm._s(_vm._f("moment")(row2.item.enqDate)))])] : undefined
      }
    }, {
      key: "POR",
      fn: function(row7) {
        return [(row7.item.shipmentType == '1') ? _c('div', [_c('span', [_vm._v("Container Type : " + _vm._s(row7.item.multipleContainerType))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("No of Containers : " + _vm._s(row7.item.multiConNo))]), _vm._v(" "), _c('br'), _vm._v(" "), (
          row7.item.newContainerFlow == '1' &&
          row7.item.shipmentType == '1' &&
          parseInt(row7.item.multiConNo) !=
          parseInt(row7.item.amendmentContainersCount)
        ) ? _c('span', {
          staticClass: "error"
        }, [_c('b', [_vm._v("Amendment Containers:\n                        " + _vm._s(row7.item.amendmentContainersCount))]), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Shipping Line : " + _vm._s(row7.item.shippingLine))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pickup : " + _vm._s(row7.item.pickup))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Stuffing : " + _vm._s(row7.item.stuffingLoc))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Handover : " + _vm._s(row7.item.handover))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Place of Receipt : " + _vm._s(row7.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), (row7.item.jobType.split(',').includes('FF')) ? _c('div', [_c('span', [_vm._v("Load Port : " + _vm._s(row7.item.LP))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Port of Discharge : " + _vm._s(row7.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Final Place of Delivery : " + _vm._s(row7.item.finalPlace))])]) : _vm._e()]) : _c('div', [_c('span', [_vm._v("\n                      Departure Airport : " + _vm._s(row7.item.AirDept) + "\n                      "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                      Destination Airport : " + _vm._s(row7.item.airDesti) + "\n                      "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                      No.of Packages : " + _vm._s(row7.item.noOfPkg) + "\n                      "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                      Cargo Received At :\n                      " + _vm._s(row7.item.cargoReceived == "1" ? "Airport" : "Warehouse") + "\n                      "), _c('br')])])]
      }
    }, {
      key: "Payment_Status",
      fn: function(row11) {
        return [_vm._v("\n                  " + _vm._s(row11.item.Payment_Status)), _c('br'), _vm._v(" "), (row11.item.subscription_status == 'Subscribed') ? _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_c('b', [_vm._v(_vm._s(row11.item.subscription_status))])]) : _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_c('b', [_vm._v(_vm._s(row11.item.subscription_status))])])]
      }
    }, {
      key: "deleteRequest",
      fn: function(row10) {
        return [_c('td', [(row10.item.deleteRequest == '0') ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '1',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Request To Delete Assignment")]) : _vm._e(), _vm._v(" "), (row10.item.deleteRequest == '0') ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq == '0' &&
          (_vm.$sessionsStorage.get('designation') == 'manager' ||
            _vm.$sessionsStorage.get('designation') == 'employee')
        ) ? _c('b', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("Sent For Delete Approval")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq == '0' &&
          (_vm.$sessionsStorage.get('designation') == 'manager' ||
            _vm.$sessionsStorage.get('designation') == 'employee')
        ) ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq != '2' &&
          (_vm.$sessionsStorage.get('designation') == 'Admin' ||
            _vm.$sessionsStorage.get('designation') == 'HOD')
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '2',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Approve Delete Request /")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '1' &&
          row10.item.ApproveRejectDelReq != '2'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '3',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Reject Delete Request")]) : _vm._e(), _vm._v(" "), (
          row10.item.deleteRequest == '0' &&
          row10.item.ApproveRejectDelReq != '2'
        ) ? _c('br') : _vm._e(), _vm._v(" "), (
          row10.item.ApproveRejectDelReq == '2' &&
          row10.item.asignDeleted != '1'
        ) ? _c('b', {
          staticClass: "showMoreData",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              _vm.execActions(
                row10.item.allModuleId,
                '4',
                row10.item.mainSalesSeries
              )
            }
          }
        }, [_vm._v("Delete Assignment")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
          row10.item.deleteRequestBy != '' &&
          row10.item.deleteRequestBy != '0'
        ) ? _c('b', [_vm._v("Requested By : " + _vm._s(row10.item.deleteRequestBy))]) : _vm._e(), _c('br'), _vm._v(" "), (
          row10.item.invoiceNoCreated != '' &&
          row10.item.invoiceNoCreated != null &&
          row10.item.invoiceNoCreated != undefined
        ) ? _c('span', [_vm._v("\n                      Invoice : " + _vm._s(row10.item.invoiceNoCreated)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row10.item.GRDetails != '' &&
          row10.item.GRDetails != null &&
          row10.item.GRDetails != undefined
        ) ? _c('span', [_vm._v("\n                      GR Details : " + _vm._s(row10.item.GRDetails)), _c('br')]) : _vm._e(), _vm._v(" "), (
          row10.item.InvoiceDetails != '' &&
          row10.item.InvoiceDetails != null &&
          row10.item.InvoiceDetails != undefined
        ) ? _c('span', [_vm._v("\n                      Invoice Details : " + _vm._s(row10.item.InvoiceDetails) + "\n                    ")]) : _vm._e()])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": "Using Component Methods"
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopMail",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopApprove",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopReject",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDelete",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseAction
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04637de8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/viewDeleteRequestAllModuleDetails.vue
// module id = 2357
// module chunks = 0